import React from 'react';
import { Box, Typography } from '@mui/material';
import PatientIntakeFormComponent from '../../components/PatientIntakeForm';

const PatientIntakeForm = ({ patientId }) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Patient Intake Form
      </Typography>
      <PatientIntakeFormComponent patientId={patientId} />
    </Box>
  );
};

export default PatientIntakeForm; 